import React from 'react';

const ToggleTabs = ({ tabs = [], activeTab, onTabChange }) => {
    return (
        <div className="flex justify-center gap-3">
            {tabs.map((tab) => (
                <button
                    key={tab.value}
                    onClick={() => onTabChange(tab.value)}
                    className={`px-4 py-1.5 text-sm md:px-6 md:py-2 md:text-base font-semibold rounded transition-colors border border-transparent ${activeTab === tab.value ? 'bg-primary text-white' : 'bg-gray-200 text-text-primary'
                        }`}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default ToggleTabs;